import * as Types from '../../__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MarkNotificationReadVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MarkNotificationRead = { __typename?: 'Mutation', markNotificationRead: boolean };


export const MarkNotificationReadDocument = gql`
    mutation MarkNotificationRead($id: ID!) {
  markNotificationRead(id: $id)
}
    `;
export type MarkNotificationReadMutationFn = Apollo.MutationFunction<MarkNotificationRead, MarkNotificationReadVariables>;

/**
 * __useMarkNotificationRead__
 *
 * To run a mutation, you first call `useMarkNotificationRead` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationRead` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationRead, { data, loading, error }] = useMarkNotificationRead({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationRead(baseOptions?: Apollo.MutationHookOptions<MarkNotificationRead, MarkNotificationReadVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationRead, MarkNotificationReadVariables>(MarkNotificationReadDocument, options);
      }
export type MarkNotificationReadHookResult = ReturnType<typeof useMarkNotificationRead>;
export type MarkNotificationReadMutationResult = Apollo.MutationResult<MarkNotificationRead>;
export type MarkNotificationReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationRead, MarkNotificationReadVariables>;